import { NavLink, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import i18n from "../../i18n";
import { getFreezePeriod } from "../../services/placeOrder/itemLookup";
import "./header.scss";
import DialogBox from "../DialogBox";
import config from "../../config/index.json";
import { useTranslation } from "react-i18next";

function ListItem({
  item,
  subMenuClass,
  setAnchorEl,
  mobileMenu,
  subMenu,
  setSubMenu,
  level = 0,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const country = useSelector((state) =>
    state?.authentication?.user ? state?.authentication?.user?.CP_COUNTRY : ""
  );
  const isAuNz = country === config.country.AU || country === config.country.NZ
  const { isCheckoutFlow } = useSelector((state) => state.cartDetails);

  const menuClicked = (ele) => {
    if (
      ele.target.attributes.href?.value === window.location.pathname &&
      isCheckoutFlow
    ) {
      dispatch({ type: "IS_ORDER_FROM_CHECKOUT", payload: true });
    }
    if (mobileMenu) {
      setAnchorEl(null);
    }
  };

  const handleSubNav = (e) => {
    e.preventDefault();
    if (mobileMenu && level === 0) {
      setSubMenu(!subMenu);
    }
  };

  const removeDot = (data) => {
    if (data?.includes(".")) {
      return data.replaceAll(".", "");
    }
    return data || "";
  };

  const getTranslation = (key) => {
    try {
      return t(`HeaderLinks.${key}`) || key;
    } catch (error) {
      return key;
    }
  };

  const hasFirstLevelSubMenu = item["sub-menu"]?.length > 0;
  const hasSecondLevelSubMenu = item["second-level-sub-menu"]?.length > 0;

  const isParentActive =
    level === 0 &&
    (item.isActive ||
      (hasFirstLevelSubMenu &&
        item["sub-menu"].some(
          (subItem) =>
            subItem.isActive ||
            (subItem["second-level-sub-menu"] &&
              subItem["second-level-sub-menu"].some(
                (secondLevelItem) => secondLevelItem.isActive
              ))
        )));

  const renderMenuItem = () => {
    if (!item.link) {
      return (
        <span className={`nav-text ${item.isActive ? "active" : ""}`}>
          {(item.name === "return.center" && isAuNz) ? getTranslation("service.return") : getTranslation(item.name)}
        </span>
      );
    }

    if (hasFirstLevelSubMenu && level === 0) {
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <span
          className={`nav-text nav-link ${isParentActive ? "active" : ""}`}
          onClick={handleSubNav}
          style={{ cursor: "pointer" }}
        >
          {getTranslation(item.name)}
        </span>
      );
    }

    if (hasSecondLevelSubMenu && level === 1) {
      return (
        <span
          className={`nav-text ${item.isActive ? "active" : ""}`}
          style={{ cursor: "default" }}
        >
          {getTranslation(item.name)}
        </span>
      );
    }

    if (item.type === "Link") {
      if (item.name === "credit.claim.dva.new") {
    return (
      <NavLink
        id={`TopMenu-LNK-${removeDot(item.name)}`}
        to={item.link}
        onClick={(e) => {
          e.preventDefault();
          ["dvaCreditClaims", "dva_partner_locations", "dva_partner_locations_expiry"]
            .forEach((key) => sessionStorage.removeItem(key));

          const isOnSamePage = window?.location?.pathname?.endsWith(item?.link);
          navigate(
            isOnSamePage ? `${item.link}?reset=true` : item.link,
            { replace: isOnSamePage }
          );
          
          menuClicked(e);
        }}
        className="nav-link"
        activeClassName="active"
      >
        {getTranslation(item.name)}
      </NavLink>
    );
  }
      return (
        <NavLink
          id={`TopMenu-LNK-${removeDot(item.name)}`}
          to={item.link}
          onClick={menuClicked}
          className="nav-link"
          activeClassName="active"
        >
          {(item.name === "create.return" && isAuNz) ? getTranslation("service.create") : 
          (item.name === "return.history" && isAuNz) ? getTranslation("service.history") : 
          getTranslation(item.name)}
        </NavLink>
      );
    }

    if (item.type === "a") {
      return (
        <a
          href={item.link || "#"}
          id={`topMenu-${removeDot(item.name)}`}
          onClick={item.link ? menuClicked : handleSubNav}
          className={`nav-link ${item.isActive ? "active" : ""}`}
        >
          {getTranslation(item.name)}
        </a>
      );
    }

    return getTranslation(item.name);
  };

  const navclass = subMenuClass || "nav__menu-item";
  const finalNavClass =
    level === 0 && isParentActive ? `${navclass} parent-active` : navclass;

  return (
    <>
      <li className={finalNavClass}>
        {renderMenuItem()}

        {/* First-level submenus */}
        {hasFirstLevelSubMenu && level === 0 && (
          <ul className={subMenu ? "nav__submenu" : "nav__submenu hide"}>
            {item["sub-menu"].map((subItem, index) => (
              <ListItem
                item={subItem}
                key={index}
                subMenuClass="nav__submenu-item"
                subMenu={subMenu}
                setSubMenu={setSubMenu}
                mobileMenu={mobileMenu}
                setAnchorEl={setAnchorEl}
                level={1}
              />
            ))}
          </ul>
        )}

        {/* Second-level submenus */}
        {hasSecondLevelSubMenu && level === 1 && (
          <ul className="nav__second-level-submenu">
            {item["second-level-sub-menu"].map((secondLevelItem, index) => (
              <ListItem
                item={secondLevelItem}
                key={index}
                subMenuClass="nav__submenu-item nav__submenu-item--second-level"
                subMenu
                setSubMenu={setSubMenu}
                mobileMenu={mobileMenu}
                setAnchorEl={setAnchorEl}
                level={2}
              />
            ))}
          </ul>
        )}
      </li>
      {!subMenuClass && <span className="divider" />}
    </>
  );
}

function getLastPath(url) {
  return url.substring(url.lastIndexOf("/") + 1);
}

const Menu = ({ mobileMenu, setAnchorEl, subMenu, setSubMenu }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { menuItems = [] } = useSelector((state) => state.headerProductSearch);
  const dispatch = useDispatch();
  const { isSalesRep } = useSelector((state) => state?.setUser);
  const { shipTo, orderType, freezePeriod } = useSelector(
    (state) => state?.cartDetails
  );
  const { shipToOrderSearch } = useSelector((state) => state?.cartDetails);
  const [freezeNotify, setFreezeNotify] = useState(false);
  const [endDate, setEndDate] = useState(false);
  const clickSearch = () => {
    if (orderType !== "DROP_SHIP") {
      if (shipTo?.value) {
        dispatch({ type: "PRODUCT_SEARCH", payload: true });
      } else {
        dispatch({ type: "SHIP_TO_ORDER_SEARCH", payload: !shipToOrderSearch });
      }
    } else {
      dispatch({ type: "PRODUCT_SEARCH", payload: true });
    }
  };

  useEffect(() => {
    if (isSalesRep) {
      dispatch({ type: 'ENABLE_SWITCH_ACCOUNT', payload: true });
      if(freezePeriod === null) {
        getFreezePeriod().then((resp) => {
          dispatch({
            type: "FREEZE_PERIOD",
            payload: resp?.data?.["freeze-period"],
          });
          if (resp?.data?.["freeze-period"].toLowerCase() === "freeze") {
            setFreezeNotify(true);
            setEndDate(resp?.data?.["end-date"]);
          } else {
            setFreezeNotify(false);
          }
        });
      }
    } 
  }, [isSalesRep]);

  if (menuItems.length === 0) {
    return null;
  }

  const listItems = menuItems.map((i, index) => {
    i.isActive = false;
    const currentPath = getLastPath(location?.pathname);

    const subMenus = i["sub-menu"];

    if (subMenus) {
      subMenus.forEach((subMenuLink) => {
        // Reset submenu active state
        subMenuLink.isActive = false;

        // Check if this submenu item matches current path
        if (subMenuLink.link === `/${currentPath}`) {
          subMenuLink.isActive = true;
          i.isActive = true;
        }

        // Handle second-level submenus
        const secondLevelSubMenus = subMenuLink["second-level-sub-menu"];
        if (secondLevelSubMenus) {
          secondLevelSubMenus.forEach((secondLevelItem) => {
            secondLevelItem.isActive = false;

            if (secondLevelItem.link === `/${currentPath}`) {
              secondLevelItem.isActive = true;
              subMenuLink.isActive = true; // Mark parent submenu as active
              i.isActive = true; // Mark main menu as active
            }
          });
        }
      });
    } else if (i.link === `/${currentPath}`) {
      i.isActive = true;
    }

    return (
      <ListItem
        key={index}
        item={i}
        subMenu={subMenu}
        setSubMenu={setSubMenu}
        mobileMenu={mobileMenu}
        setAnchorEl={setAnchorEl}
      />
    );
  });

  return (
    <>
      <div className="navbar">
        <ul className={mobileMenu ? "nav__menu mobile" : "nav__menu"}>
          {listItems}
          {location?.pathname === "/order" && !mobileMenu && (
            <li className="nav__menu-item search_product">
              <SearchIcon id="po-product-search" onClick={clickSearch} />
            </li>
          )}
        </ul>
      </div>
      {freezeNotify && (
        <DialogBox
          title={t("salesRep.endQuarterNotice")}
          saveLable={t("placeOrder.buttonsLabel.ok")}
          onCancel={() => setFreezeNotify(false)}
          openDialog={freezeNotify}
          setOpenDialog={setFreezeNotify}
          className="dialogPaper"
          width="xs"
        >
          {i18n.t("salesRep.endQuarterNoticeMsg", { endDate })}
        </DialogBox>
      )}
    </>
  );
};

export default Menu;
